"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CoreWrap = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _redux = _interopRequireDefault(require("./redux"));
var _AzureWrap = require("../Azure/AzureWrap");
var _constants = require("../utils/constants");
var _Localization = require("../Localization");
var _Connects = require("./Connects");
var _Types = require("../Types");
var _ToastWrapper = require("../components/ToastWrapper");
require("swiper/css");
require("swiper/css/navigation");
require("swiper/css/pagination");
require("../styles/main.css");
require("../styles/_fonts.less");
var _ThemeProvider = require("../features/provider/ThemeProvider");
var _InjectCore = require("./InjectCore");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// eslint-disable-next-line import/no-unresolved

// eslint-disable-next-line import/no-unresolved

// eslint-disable-next-line import/no-unresolved

/**
 * CoreWrap wrap for connect Azure, Localization and core provider
 * @param {Record<string, string>} urls list of backend urls
 * @param {JSX.Element}  children Site content
 * @param {string} theme The theme of site (temporary), can be all variant from themeKey
 * @param {Required} authFile File to set login settings, if null - default auth file for local development is used
 * @param {JSX.Element} loginComponent Custom login page, only as a Tag
 * @example
 *
 * loginComponent={<LoginPage />}
 *
 * @returns {JSX.Element}
 *
 * @public
 */
/** @todo: We should not to wrap into useMemo all jsx. It is wrong way. I think, we should use memo HOC here. */
const CoreWrap = _ref => {
  let {
    loginComponent = null,
    theme,
    authFile = null,
    children,
    urls
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
    store: (0, _redux.default)()
  }, /*#__PURE__*/_react.default.createElement(_InjectCore.InjectCore, null, /*#__PURE__*/_react.default.createElement(_Localization.Localization, {
    detectLocale: true
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.HashRouter, null, /*#__PURE__*/_react.default.createElement(_ThemeProvider.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_AzureWrap.AzureWrap, {
    loginComponent: loginComponent,
    authFile: authFile
  }, /*#__PURE__*/_react.default.createElement(_Connects.Connects, {
    urls: urls
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children, /*#__PURE__*/_react.default.createElement(_ToastWrapper.ToastWrapper, null)))))))));
};
exports.CoreWrap = CoreWrap;
CoreWrap.propTypes = {
  loginComponent: _propTypes.default.element,
  theme: _Types.themeType,
  authFile: _Types.AuthFileType,
  urls: _Types.urlsTypes,
  children: _propTypes.default.element.isRequired
};
CoreWrap.defaultProps = {
  urls: _Types.urlsTypesDefault,
  theme: _constants.defaultTheme,
  authFile: null,
  loginComponent: null
};